import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import Config from '../../../helpers/Config';
import { MakeApiCallAsync } from '../../../helpers/ApiHelpers';
import { getLanguageCodeFromSession } from '../../../helpers/CommonHelper';
import './CompactCampaignSection.css';
import { getPromotionUrl } from '../../../helpers/PromotionLinks';

const CompactCampaignSection = () => {
    const [campaigns, setCampaigns] = useState([]);

    useEffect(() => {
        let mounted = true;
        const loadCampaigns = async () => {
            try {
                const response = await MakeApiCallAsync(
                    Config.END_POINT_NAMES.GET_WEB_CAMPAIGN_LIST, null,
                    { requestParameters: { recordValueJson: '[]' } },
                    { Accept: 'application/json', 'Content-Type': 'application/json' }, 'POST', true
                );
                if (mounted && response?.data?.data) {
                    const data = JSON.parse(response.data.data);
                    setCampaigns(Array.isArray(data) ? data : []);
                }
            } catch (error) {
                console.error('Unable to load compact promotions', error);
            }
        };
        loadCampaigns();
        return () => { mounted = false; };
    }, []);

    if (!campaigns.length) return null;

    const imageUrl = item => {
        const path = String(item.CoverPictureUrl || '').replace(/\\/g, '/');
        return /^https?:\/\//i.test(path) ? path : `${Config.ADMIN_BASE_URL.replace(/\/$/, '')}/${path.replace(/^\//, '')}`;
    };
    const detailUrl = item => getPromotionUrl(item, getLanguageCodeFromSession());

    return <section className="compact-promotions" aria-labelledby="compact-promotions-title">
        <div className="compact-promotions__inner">
            <div className="compact-promotions__heading">
                <div>
                    <span>Don't miss out</span>
                    <h2 id="compact-promotions-title">Top Promotions</h2>
                </div>
                <i className="fas fa-tags" aria-hidden="true" />
            </div>

            <div className="compact-promotions__list">
                {campaigns.map((item, index) => <Link className="compact-promotion-card" to={detailUrl(item)} key={item.CampaignId || index}>
                    <span className="compact-promotion-card__image">
                        <img src={imageUrl(item)} alt="" loading="lazy" />
                    </span>
                    <span className="compact-promotion-card__content">
                        {item.DiscountTitle && <small>{item.DiscountTitle}</small>}
                        <strong>{item.MainTitle || 'Special offer'}</strong>
                        <span>Explore offer <i className="fas fa-arrow-right" aria-hidden="true" /></span>
                    </span>
                </Link>)}
            </div>
        </div>
    </section>;
};

export default CompactCampaignSection;
